import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 140px 100px 65px 150px auto auto
  grid-template-areas: 'date alias mode ip_address total_ips total_diff_ips';
  grid-column-gap: 0.5rem;
`;
